<template>
  <div style="margin-top: 30px; padding:11px;">
    <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
      OSGB Satış Tutarı Ekle
    </button>
    <br>
    <div class="table-responsive">
      <table class="table align-middle">
        <thead>
        <tr>
          <td><b>OSGB Satış Tutarı</b></td>
          <td><b>Açıklama</b></td>
          <td><b>İşlemler</b></td>
        </tr>
        </thead>

        <tbody>
        <tr v-for="val in osgbSalesData" v-bind:key="val.id">
          <td><b>{{ formatCurrency(val.osgbSalesAmount) }}</b></td>
          <td>{{ val.description }}</td>
          <td>
            <button type="button" class="btn btn-danger"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteModal"
                    @click="setDeleteId(val.id)">Sil</button>
            &nbsp;
            <button type="button" class="btn btn-secondary"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    @click="editOsgbSales(val)">Düzenle</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Silme Modal -->
    <div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteModalLabel">Silme Onayı</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>Bu öğeyi silmek istediğinizden emin misiniz?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">İptal</button>
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="deleteOsgbSales(deleteId)">Evet, Sil</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Ekleme/Düzenleme Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content" style="min-height: 500px; width: 750px; display: flex; flex-direction: column;">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ isEditing ? 'OSGB Satış Tutarı Düzenle' : 'OSGB Satış Tutarı Ekle' }}</h5>
            <button type="button" style="background-color: #2419d2;" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body" style="overflow-y: auto;">
            <div class="mb-3">
              <label for="amountInput" class="form-label">OSGB Satış Tutarı</label>
              <input type="number" class="form-control" id="amountInput" v-model="itemsOsgbSales.osgbSalesAmount" placeholder="OSGB Satış Tutarı" min="0" step="0.01">
            </div>
            <div class="mb-3">
              <label for="descriptionInput" class="form-label">Açıklama</label>
              <input type="text" class="form-control" id="descriptionInput" v-model="itemsOsgbSales.description" placeholder="Açıklama">
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Vazgeç</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="isEditing ? updateOsgbSales() : saveOsgbSales()">
              {{ isEditing ? 'Güncelle' : 'Kaydet' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ts-nocheck
import apiClient from "@/axios";

export default {
  name: "OsgbSalesAmount",
  data() {
    return {
      osgbSalesData: {},
      deleteId: null,
      isEditing: false,
      itemsOsgbSales: {
        osgbSalesAmount: null,
        description: '',
        id: null,
      },
    };
  },
  created() {
    this.getOsgbSalesData();
  },
  methods: {
    saveOsgbSales() {
      apiClient.post("/osgb-sales-amount", this.itemsOsgbSales).then(() => {
        this.getOsgbSalesData();
        this.itemsOsgbSales = { osgbSalesAmount: null, description: '' };
      })
          .catch(error => {
            console.error("Kaydetme işlemi sırasında hata oluştu:", error);
          });
    },

    getOsgbSalesData() {
      apiClient.get("/osgb-sales-amount").then(res => {
        this.osgbSalesData = res.data;
      });
    },

    setDeleteId(id) {
      this.deleteId = id;
    },

    deleteOsgbSales(id) {
      apiClient.delete(`/osgb-sales-amount/${id}`)
          .then(() => {
            this.getOsgbSalesData();
          })
          .catch(error => {
            console.error("Silme işlemi sırasında hata oluştu:", error);
          });
    },

    formatCurrency(value) {
      if (value !== undefined && value !== null) {
        return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(value);
      }
      return "₺0,00";
    },

    editOsgbSales(osgbSales) {
      this.itemsOsgbSales = {
        osgbSalesAmount: osgbSales.osgbSalesAmount,
        description: osgbSales.description,
        id: osgbSales.id
      };
      this.isEditing = true;
    },

    updateOsgbSales() {
      apiClient.put(`/osgb-sales-amount`, this.itemsOsgbSales).then(() => {
        this.getOsgbSalesData();
        this.isEditing = false;
        this.itemsOsgbSales = { osgbSalesAmount: null, description: '' };
      }).catch(error => {
        console.error("Güncelleme işlemi sırasında hata oluştu:", error);
      });
    },
  },
}
</script>

<style scoped>
</style>
